import { useState } from "react";
import { Lock, Loader2, ShieldCheck, CreditCard } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function CheckoutModal({
  open, onOpenChange, title, subtitle, lines = [], total, confirmLabel = "Conferma pagamento", onConfirm,
}) {
  const [processing, setProcessing] = useState(false);

  const handleConfirm = async () => {
    setProcessing(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !processing && onOpenChange(v)}>
      <DialogContent className="bg-[#1A1A1A] border-white/10 text-white" data-testid="checkout-modal">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <CreditCard className="w-5 h-5 text-[#E91E8C]" /> {title}
          </DialogTitle>
          <DialogDescription className="text-white/50">{subtitle}</DialogDescription>
        </DialogHeader>

        <div className="rounded-2xl border border-white/10 bg-[#0D0D0D] p-5 space-y-3">
          {lines.map((l, i) => (
            <div key={i} className="flex justify-between text-sm">
              <span className="text-white/60">{l.label}</span>
              <span className="font-medium">{l.value}</span>
            </div>
          ))}
          <div className="border-t border-white/10 pt-3 flex justify-between">
            <span className="font-semibold">Totale</span>
            <span className="text-xl font-black font-heading text-[#E91E8C]" data-testid="checkout-total">
              €{Number(total).toFixed(2)}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2 text-xs text-white/40 my-1">
          <ShieldCheck className="w-4 h-4 text-[#F5C6D6]" />
          Pagamento simulato · nessun dato di carta reale richiesto
        </div>

        <Button
          onClick={handleConfirm} disabled={processing} data-testid="checkout-confirm"
          className="cta-pulse w-full h-12 rounded-xl bg-[#E91E8C] hover:bg-[#D8157B] text-white font-semibold"
        >
          {processing ? <Loader2 className="w-5 h-5 animate-spin" /> : (
            <><Lock className="w-4 h-4 mr-2" /> {confirmLabel}</>
          )}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
